export default "__VITE_ASSET__BjenC07P__"